//
//
//
//

export default{
  data() {
    return {
      content: this.$t('withdrawRecord.footer')
    }
  },
  methods: {
    connect() {
      this.contactMe()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.vue